// from general.js
/* global toggleSignInOverlay submitFormToIframe */

import vanityURLForm from './vanityURLForm.tmpl';
import { requireLoginForPageUpdate } from '../utils/userUtils.js';

function submitVanityURLForm() {
    $(window).off('userCookiesReset.submitVanityURLForm');
    if (requireLoginForPageUpdate()) {
        toggleSignInOverlay(null, true);
        $(window).on('userCookiesReset.submitVanityURLForm', submitVanityURLForm);
        return;
    }
    if (!validateVanityURLField()) {
        return;
    }
    submitFormToIframe($('#vanity-url-form')[0], 'teacherVanityURLIframe');
}

export const editVanityURL = function () {
    $(window).off('userCookiesReset.editVanityURL');
    if (requireLoginForPageUpdate()) {
        toggleSignInOverlay(null, true);
        $(window).on('userCookiesReset.editVanityURL', function () { editVanityURL(); });
        return;
    }

    if ($('#vanity-url-form').length === 0) {
        const htmlV = renderVanityURLForm(vanityType, null, window.challengeName, window.challengeId);
        if ($('#vanity-url-placeholder').length > 0) {
            $('#vanity-url-placeholder').html(htmlV);
        } else {
            $('#vanity-url-link').after(htmlV);
        }
        $('.js-check-availability-link').on('click', checkVanityURLAvailability);
        $('.js-submit-vanity-form-button').on('click', submitVanityURLForm);
        $('.js-vanity-url-form').on('submit', function (e) {
            submitVanityURLForm();
            e.preventDefault();
        });
        // get examples
        if (vanityType != 'challenge') {
            const examplesURL = $('#vanity-url-form').attr('action');
            const vanityTypeParam = $('#vanity-url-form input[name=vanityType]').val();
            const callbackName = 'getVanityURLExamplesCallback';
            fetchVanityURLExamples(examplesURL, vanityTypeParam, callbackName);
        }
    }
    $('#vanity-url-link').hide();
};

function fetchVanityURLExamples(examplesURL, vanityTypeParam, callbackName) {
    // var urlString = secureBaseURL+"common/vanity-url.html?vanityType=teacher&callback=getVanityURLExamplesCallback&getVanityURLExamples=true";
    examplesURL = setURLParam(examplesURL, 'vanityType', vanityTypeParam);
    examplesURL = setURLParam(examplesURL, 'getVanityURLExamples', 'true');
    examplesURL = setURLParam(examplesURL, 'callback', callbackName);
    const e = document.createElement('script');
    e.src = examplesURL;
    e.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(e);
}

/**
 * Returns the raw HTML formed by rendering the vanity URL form Handlebars template.
 * @param vanityType
 * @param examples
 * @param challengeName
 * @param challengeId
 */
function renderVanityURLForm(vanityType, examples, challengeName, challengeId) {
    const context = [];
    context.vanityType = vanityType;
    if (vanityType == 'challenge') {
        context.examples = [challengeName.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')];
        context.challengeId = challengeId;
    } else if (examples) {
        context.examples = examples;
    }

    return vanityURLForm(context);
}

// JSONP callback
window.getVanityURLExamplesCallback = function (response) {
    if (response && response.data && response.data.examples) {
        const examples = response.data.examples;
        let examplesString = '';
        for (let i = 0; i < examples.length; i++) {
            examplesString += '<li>' + baseURL + examples[i] + '</li>';
        }
        $('#vanity-url-examples').html(examplesString);
    }
};

function validateVanityURLField() {
    if ($('#vanityURL').val() === '') {
        $('#vanity-url-form .error-text').html('Please enter a custom url.');
        return false;
    }
    return true;
}

// This is called from an onclick handler in vanityURLForm.jsp
// Can that work with our CSP?
window.checkVanityURLAvailability = function () {
    if (!validateVanityURLField()) {
        return;
    }
    let checkAvailabilityURL = $('#vanity-url-form').attr('action');
    checkAvailabilityURL = setURLParam(checkAvailabilityURL, 'checkAvailability', 'true');
    checkAvailabilityURL = setURLParam(checkAvailabilityURL, 'vanityURL', $('#vanityURL').val());
    checkAvailabilityURL = setURLParam(checkAvailabilityURL, 'callback', 'vanityURLAvailabilityCallback');

    const e = document.createElement('script');
    e.src = checkAvailabilityURL;
    e.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(e);
};

window.vanityURLAvailabilityCallback = function (response) {
    $('#vanity-url-form .error-text').html(response.data.message);
};

// JSONP callback from vanityURLForm.tmpl
window.vanityURLCallback = function (response) {
    if (response && response.data.success) {
        $('#vanity-url-form').after('<div id="vanity-url-success">Success!  Please allow 5 minutes for our systems to update.</div>');
        $('#public-url-link').attr('href', baseURL + response.data.vanityURL);
        $('#public-url-link,#teacher-url').text(baseURL + response.data.vanityURL);
        $('#vanity-url-form').hide();
        rebuildShareLinks(baseURL + response.data.vanityURL);
    } else if (response.data.signinRequired) {
        alert('Please first sign in to make this change.');
    } else if (response.data.message) {
        $('#vanity-url-form .error-text').html(response.data.message);
    } else {
        $('#vanity-url-form .error-text').html('We were not able to save your custom url.  Please try again later.');
    }
};

function rebuildShareLinks(vanityURL) {
    if (typeof originalURL !== 'undefined') {
        $('.shareByFacebook').each(function () {
            rebuildShareLink(this, vanityURL);
        });
        $('.shareByEmail').each(function () {
            rebuildShareLink(this, vanityURL);
        });
        $('.shareByTwitter').each(function () {
            rebuildShareLink(this, vanityURL);
        });
        $('.shareByPinterest').each(function () {
            rebuildShareLink(this, vanityURL);
        });
    }
}

/* global originalURL */ // from public-info.html
function rebuildShareLink(el, vanityURL) {
    if (typeof originalURL === 'undefined') return;
    let facebookURL = $(el).attr('href');
    let re = new RegExp(originalURL, 'g');
    facebookURL = facebookURL.replace(re, vanityURL);
    re = new RegExp(encodeURIComponent(originalURL), 'g');
    facebookURL = facebookURL.replace(re, encodeURIComponent(vanityURL));
    $(el).attr('href', facebookURL);
}
